import { FC } from 'react';

import { Document, Page, pdfjs } from 'react-pdf';

import { LoadingIndicator } from '@cfa/react-core';

import GetPdfButton from './components/GetPdfButton';
import { useElementWidth, useParsePdfHtmlContent } from './hooks';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

interface PdfContentProps {
  htmlContent?: string;
}

const PdfContent: FC<PdfContentProps> = ({ htmlContent }) => {
  const pdfContentParseResult = useParsePdfHtmlContent(htmlContent);
  const [wrapperRef, width] = useElementWidth();

  if (!htmlContent || !pdfContentParseResult) {
    return null;
  }

  const [pdf, parseError] = pdfContentParseResult;

  if (parseError || !pdf) {
    return null;
  }

  return (
    <div ref={wrapperRef} className="flex flex-col gap-5">
      <Document
        file={pdf.pdfSrc}
        options={{ withCredentials: true }}
        loading={
          <div className="flex aspect-video items-center justify-center">
            <LoadingIndicator />
          </div>
        }
      >
        {width && (
          <div className="shadow-elevation-4 relative aspect-video overflow-hidden rounded-lg">
            <div className="from-base-0 pointer-events-none absolute inset-x-0 bottom-0 z-10 h-16 bg-linear-to-t to-transparent" />
            <Page
              pageNumber={1}
              width={width}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </div>
        )}
      </Document>
      {pdf.description && (
        <p className="text-variant-body1">{pdf.description}</p>
      )}
      <GetPdfButton pdfSrc={pdf.pdfSrc} />
    </div>
  );
};

export default PdfContent;
